/*
 * @Author: Soul
 * @Date: 2021-05-31 17:23:14
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-01 15:14:02
 * @Description: file content
 */
export default {
  env: {
    // actId: 555
    // appId: wx9d18b85133ff72a2
    // 平台1域名1 web.ruthyx.com	
    // 平台1域名2 web.ruth6666.com	
    // 平台1域名3 web.ruthznyx.com
    // 活动API: https://actapi2.ttrsznkj.com/yq-oop-cifi/doc.html
    // 核销api: https://actapi2.ttrsznkj.com/act-data/doc.html
    prod: {
      site: {
        appid: "wx9d18b85133ff72a2",
        protocol: "http:",
        domain: "web.ruthyx.com",
      },
      routersActWxauth: {
        fake: {
          test: {
            actOpenId: 'oCNfNv6zf8_Q8KwzzVXi4U3Nch1g',
            actAppId: 'wx9d18b85133ff72a2',
          },
          zt: {
            actOpenId: 'oCNfNv5bSSDV0GQbEMUgyx0J778s',
            actAppId: 'wx9d18b85133ff72a2',
          },
          gj: {
            actOpenId: 'oCNfNvzcvgW5NQxX6AnebeZsfwOc',
            actAppId: 'wx9d18b85133ff72a2',
          },
          lz: {
            actOpenId: 'oCNfNvzEWvoKvNrlQKaIFM9J7hGY',
            actAppId: 'wx9d18b85133ff72a2',
          },
          // oCNfNv8lDyX4csRtMZt9DtOW6QDc
          // oCNfNvzcvgW5NQxX6AnebeZsfwOc
          // oCNfNvyywMtBbPB52pHMBVVEydgg
          // oCNfNv0xKwiY6uhKlvXHQ8Gqbygg
          // oCNfNv-8L0yo3yxZ-6ve_JdupH_8
          // oCNfNv_vzeI-9CDJrdTm15uN6T0E
          // oCNfNv1vh-QnZjpk2m9ympQG1qEE
          // oCNfNvw1gzn4-vQuMH50PE_uxIgk
          // oCNfNv7z7Mr8BStbHIt0CP0RJZDo
          // oCNfNvzikV09LqCsw-MnZfXHs83U
          // oCNfNv6M8fCxMfUtWP-9nninVoaw
          // oCNfNvzRc2DW25THWm2Fnq5QiDPo
          // oCNfNv1n-64UVVxqt4kgToCSXrG0
          // oCNfNv37uL-ueUdFUEOxFRkDqH_o
          // oCNfNvxAtIpAJOB_yaT_yoygcW_c
          // oCNfNv0tK6I8j-eB04LFyxbmhblg
          // oCNfNv8FUiuMhjFiR6204ZtGy6hY
          // oCNfNv5CVZug0gL000wv8Zh7Tu3U
          // oCNfNv9uw7InmJAPSYshVjB1FdHE
          // oCNfNvw6FuskpPF1ukELK6ZqjRh4
        }
      },
      servicesActWxjssdk: {
        appid: 'wxa3688bcc3a5fd4e2',
        // appid: 'wx9d18b85133ff72a2',
      },
      apiActWxauth: {
        appid: "wx9d18b85133ff72a2",
        protocol: "http:",
        domain: "web.ruthyx.com"
      },
      apiActLogicPlatform: {
        protocol: "http:",
        domain: "web.ruthyx.com",
      },
      apiActLogicDengfan: {
        protocol: "https:",
        domain: "actapi2.ttrsznkj.com",
      },
      httpActLogicDengfan: {
        appId: "wx9d18b85133ff72a2",
        actId: 555,
        token: 'df5fe49858504c25bb7518410aaf70a2' //核销奖品所需要的token
      },
      apiRushiH5Platform: {
        protocol: "http:",
        domain: "ygcgz.ttrushi.com",
      },
      httpRushiH5Platform: null,
      servicesRushiH5jssdk: {
        pageid: 306535,
        psn: "bcf988435a4048f1a6e4e386b69b6442",
        projectid: 8057,
        saleslead: {
          browse: true,
          share: true,
          leavePhone: true
        }
      },
      apiRushiWxPlatform: {
        protocol: "http:",
        domain: "ygcgz.ttrushi.com",
      },
      httpRushiWxPlatform: {
        borrowOpenid: 'og2HS5gm-SAafiJhFuXY-4m_VUuY',
        borrowPassport: '781930234641d3e39fd22629eff1653d'
      }
    },
  },
  APPID: 'wx9d18b85133ff72a2',
  actId: 555,
  bizId: 'd40ac2204d804436a7df4f18ab9bf6a6  ',
  projectId: 2597,
  audioSrc: 'http://assets.rurushishi.com/activies/rchd-blind-box-2021-11/bgm.mp3', //背景音乐 格式mp3 大小1M以内
  apiName: 'yq-oop-cifi', // 接口名字
  imgHost: 'http://assets.rurushishi.com/activies/dy-house-2022-10/', // 静态素材oss地址
  company: '开发商', // 免责声明公司名
  prizeTime: '11月30日之前', // 领奖时间
  shareTitle: '邀您共同参与一块钱买一平米！东原双十一真诚购房节，真诚无套路！', // 分享标题
  shareContent: '不耍花腔，1元买1平米！拒绝套路，好礼无限抽！', // 分享内容
  pageTitle: '东原双十一 真诚购房节', // 页面头部标题
  OSSVersion: 0, // 静态资源版本号防止图片缓存，替换同名图片后修改此处
  openDebug: false, // 开启vclonse调试模式
  openYqAnalytics: false, // 开启原圈数据统计监控
  openSalesLeads: false,  // 开启销售线索

  addressList: [
    { name: '华中区域', city: ['武汉', '石家庄', '长沙', '襄阳', '郑州','不限区域'], key: 1, infoId: 556, areaId: [556, 557, 558, 559,575], hasSignUp: true },
    { name: '西南区域', city: ["重庆", "昆明", "贵阳",], key: 3, infoId: 560, areaId: [560, 561, 562], hasSignUp: true },
    { name: '浙江区域', city: ["衢州", "杭州",], key: 4, infoId: 563, areaId: [563, 564], hasSignUp: true },
    { name: '苏沪区域', city: ["南京", "南通", "苏州", "徐州",], key: 5, infoId: 565, areaId: [565, 566, 567, 568], hasSignUp: true },
    { name: '华西区域', city: ["渭南", "成都", "宜宾", "绵阳",], key: 2, infoId: 569, areaId: [569, 570, 571, 572], hasSignUp: true },
    { name: '广州区域', city: ["江门", "肇庆",], key: 2, infoId: 573, areaId: [573, 574], hasSignUp: true },
  ],
  projectList: [
    {
      region: '华中区域',
      intro: [
        {
          name: "武汉印柒雅",
          id: 11,
          projectId: 11445,
          signInfo: [
            { signTitle: 1, signAdd: "湖北省武汉市洪山区文佳巷7号", signNum: 10, time: "11月11-13日", id: 11 }
          ],
          info: {
            picId: "1", name: "武汉印柒雅", address: "湖北省武汉市洪山区文佳巷7号", txt: "街道口南<br/>酒店式场景大宅",
            txtLine: 3, tel: "027-83378888", position: "114.34,30.50",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt7742&hasFullScreenPics=3'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "来访可得购物卡激励", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "税前4万/套， 额外加享费尔蒙酒店下午茶套餐", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "襄阳千江印月",
          id: 12,
          projectId: 11447,
          signInfo: [
            { signTitle: 2, signAdd: "襄阳市东津新区南山路与荆山路交汇处", signNum: 10, time: "11月5日-6日;11月12-13日" }
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "有效带看即可奖励1.8L升金龙鱼油一壶", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "2%佣金", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: "2", name: "襄阳千江印月", address: "襄阳市东津新区南山路与荆山路交汇处", txt: "东津南奇幻度假区旁<br/>百万方教育大城",
            txtLine: 3, tel: "0710-3779999", position: "112.24,32.01",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt5084&hasFullScreenPics=4'
          }
        },
        {
          name: "长沙启城",
          id: 13,
          projectId: 11379,
          signInfo: [
            { signTitle: 1, signAdd: "长沙市望城区双桂路与汤家湖路交汇处东原启城营销中心", signNum: 10, time: "11月11-13日", id: 13 }
          ],
          info: {
            picId: "3", name: "长沙启城", address: "长沙市望城区双桂路与汤家湖路交汇处东原启城营销中心",
            txt: "6字头 青竹湖畔<br/>师大附中旁<br/>全龄无忧社区", txtLine: 3, tel: "0731-89778888", position: "112.95,28.36",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt2348&hasFullScreenPics=5'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "来访可参与幸运大转盘赢生活好礼", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主享受总房款2%奖励（税前）+1年物业费；", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "长沙麓印长江",
          id: 15,
          projectId: 11446,
          signInfo: [{ signTitle: 1, signAdd: "湖南省长沙市开福区锦绣路与福元路交汇处麓·印长江营销中心", signNum: 10, time: "11月11-13日", id: 15 }],
          info: {
            picId: "5", name: "长沙麓印长江", address: "湖南省长沙市开福区锦绣路与福元路交汇处麓·印长江营销中心",
            txt: "广电旁 双地铁<br/>半山低密现房", txtLine: 3, tel: "0731-84137777", position: "113.06,28.24",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt2342&hasFullScreenPics=5'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "到访即可案场免费抽盲盒", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主享受税前最高3万/套激励；", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "武汉印未来",
          id: 16,
          projectId: 11377,
          signInfo: [
            { signTitle: 1, signAdd: "东西湖区滨河南路与径河八路交汇处", signNum: 10, time: "11月12-13日", id: 16 }
          ],
          info: {
            picId: "6", name: "武汉印未来", address: "东西湖区滨河南路与径河八路交汇处", txt: "临空港芯 豪宅级品质<br/>单价不过万·改善必看",
            txtLine: 3, tel: "027-87517777", position: "114.12,30.67",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt3264&hasFullScreenPics=5'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "精美暖冬礼品", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "税前2万/套， 新业主赠送3000元家电，专享99折", info: "老业主推荐的客户签约成交" }]
        },
        {
          name: "武汉朗阅", id: 17, projectId: 11444,
          signInfo: [{ signTitle: 1, signAdd: "武汉新洲区阳逻平江大道与汉施大道交叉口东侧", signNum: 10, time: "11月11-13日", id: 17 }],
          info: {
            picId: "7", name: "武汉朗阅", address: "武汉新洲区阳逻平江大道与汉施大道交叉口东侧", txt: "汉口前站湖岸现房<br/>地铁改善首选",
            txtLine: 3, tel: "027-88878885", position: "114.56,30.70",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt2339&hasFullScreenPics=5'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "来访免费接送，且有油卡好礼送", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "税前2万元/套佣金", info: "老业主推荐的客户签约成交" }]
        },
        {
          name: "石家庄启城",
          id: 14,
          projectId: 11448,
          signInfo: [{ signTitle: 2, signAdd: "河北省石家庄市长安区体育大街古城路交会处向西约600米路北", signNum: 10, time: "11月5日-6日;11月12-13日", id: 14 }],
          info: {
            picId: "4", name: "石家庄启城", address: "河北省石家庄市长安区体育大街古城路交会处向西约600米路北", txt: "滹沱河畔 实景准现<br/>低密生态大宅",
            txtLine: 3, tel: "0311-88990000", position: "114.545447,38.10411",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt3980&hasFullScreenPics=2'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "有效带看即可奖励1.8L升金龙鱼油一壶", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "1.5%佣金，老带新成交额外奖励老业主及新客户各2000", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "郑州满庭芳",
          id: 39,
          projectId: 11378,
          signInfo: [{ signTitle: 1, signAdd: "郑州市中牟县文博路与中兴路交叉路口往西北约100米", signNum: 10, time: "11月12-13日", id: 39 }],
          info: {
            picId: "26", name: "郑州满庭芳", address: "郑州市中牟县文博路与中兴路交叉路口往西北约100米", txt: "城中芯 实景准现<br/>品质生活社区",
            txtLine: 3, tel: "0371-60259999", position: "114.002237,34.709162",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt3632&hasFullScreenPics=4'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "有效带看即可奖励水果礼盒一件", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主享受3%佣金", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "郑州阅城",
          id: 49,
          projectId: 11460,
          signInfo: [{ signTitle: 1, signAdd: "河南省郑州市中原区高新区西三环与三全路交汇处向南200米", signNum: 10, time: "11月11-13日", id: 40 }],
          info: {
            picId: "27", name: "郑州阅城", address: "河南省郑州市中原区高新区西三环与三全路交汇处向南200米", txt: "西三环 贾鲁河畔<br/>双实验学府大城",
            txtLine: 3, tel: "0371-58528888", position: "113.596901,34.827162",
            path: '/pages/exhibitionHall/multiProject/detail.html?projectCode=dyjt2340&hasFullScreenPics=4'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "到访送精美水杯一个", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "成交老业主享1%税前佣金", info: "老业主推荐的客户签约成交" }
          ]
        }
      ]
    },
    {
      region: '西南区域',
      intro: [
        {
          name: "贵阳朗阅",
          projectId: 11438,id: 18,
          signInfo: [
            { signTitle: 3, signAdd: "贵州省贵阳市清镇市水塘路东原朗阅营销中心", signNum: 10, time: "11月5日", id: 18 },
            { signTitle: 4, signAdd: "贵州省贵阳市清镇市水塘路东原朗阅营销中心", signNum: 10, time: "11月12日", id: 18 }
          ],
          info: {
            picId: "8", name: "贵阳朗阅", address: "贵州省贵阳市清镇市水塘路东原朗阅营销中心", txt: "15年公立教育配套<br/>实景品质生活住区",
            txtLine: 3, tel: "0851-82568666", position: "106.436513,26.57766",
            path: '/pages/redirect/index.html.html?scene=N88UR33i'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "到访即可领取碗具套装（新老客户）", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "1万元/套（税前）", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "昆明印1905",
          projectId: 11439,id:19 ,
          signInfo: [
            { signTitle: 28, signAdd: " 昆明五华区西北新城宜家旁沙河北路东原印1905营销中心", signNum: 10, time: "11月5日",id:19 },
            { signTitle: 5, signAdd: " 昆明五华区西北新城宜家旁沙河北路东原印1905营销中心", signNum: 10, time: "11月12日",id:19 }
          ],
          info: {
            picId: "9", name: "昆明印1905", address: "昆明五华区西北新城宜家旁沙河北路东原印1905营销中心", txt: "昆明改善标杆，必看东原<br/>市心院墅，<br/>东原未来城市综合体",
            txtLine: 3, tel: "0871-68336111", position: "102.66742,25.0973",
            path: '/pages/redirect/index.html?scene=mG6GrjRd'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "暖冬精美礼品（新老业主都有）", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "佣金高层1%，商业2%，叠墅3万", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "昆明启城",
          projectId: 11371,id:21, 
          signInfo: [
            { signTitle: 32, signAdd: " 云南省昆明市官渡区大板桥东原启城营销中心", signNum: 10, time: "11.5" ,id:21},
            { signTitle: 33, signAdd: " 云南省昆明市官渡区大板桥东原启城营销中心", signNum: 10, time: "11.6" ,id:21},
            { signTitle: 34, signAdd: " 云南省昆明市官渡区大板桥东原启城营销中心", signNum: 10, time: "11.12",id:21 },
            { signTitle: 35, signAdd: " 云南省昆明市官渡区大板桥东原启城营销中心", signNum: 10, time: "11.13",id:21 }
          ],
          info: {
            picId: "11", name: "昆明启城", address: "云南省昆明市官渡区大板桥东原启城营销中心", txt: "空港心 千亩大城<br/>臻装2.0 迭代新作",
            txtLine: 3, tel: "0871-63306667", position: "102.868271,25.029727",
            path: '/pages/redirect/index.html?scene=rlkm5NZX'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "生活大礼包（新老业主都有）", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "1万元佣金（税前）", info: "老业主推荐的客户签约成交" }
          ]
        },
        {
          name: "遵义九章赋",
          projectId: 11372,id:20,
          signInfo: [
            { signTitle: 30, signAdd: "贵州省遵义市红花岗区新蒲大道与双山路交汇处东原九章赋营销中心", signNum: 10, time: "11月6日" ,id:20},
            { signTitle: 31, signAdd: "贵州省遵义市红花岗区新蒲大道与双山路交汇处东原九章赋营销中心", signNum: 10, time: "11月12/13日" ,id:20},
            { signTitle: 29, signAdd: "贵州省遵义市红花岗区新蒲大道与双山路交汇处东原九章赋营销中心", signNum: 10, time: "11月5/12日" ,id:20}
          ],
          info: {
            picId: "28", name: "遵义九章赋", address: "贵州省遵义市红花岗区新蒲大道与双山路交汇处东原九章赋营销中心",
            txt: "湿地公园旁<br/>市芯低密墅区", txtLine: 3, tel: "0851-28798888", position: "107.015488,27.697322",
            path: '/pages/redirect/index.html?scene=lxiLrvH7'
          },
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "暖手抱枕（新老客户）", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主推荐新客户成交享<br/>（高层（税前）：8000元/ 套，<br/>别墅（税前）：20000元/套）", info: "老业主推荐的客户签约成交" }
          ]
        }
      ]
    },
    {
      region: '浙江区域',
      intro: [
        {
          name: '杭州钱塘印未来',
          projectId: 11440,id:22, 
          signInfo: [
            { signTitle: 36, signAdd: '杭州市钱塘区新湾街道闸口路950号', signNum: 10, time: '11月度',id:22},
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "定制雨伞", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "大平层8万/套大，商铺4万/套", info: "老业主推荐的客户签约成交" }
          ],
          info: { picId: '12', name: '杭州钱塘印未来', address: '杭州市钱塘区新湾街道闸口路950号', 
          txt: `300方钜幕平层，大有想象<br/>高铁TOD21-300方重餐饮活力街区`, 
          txtLine: 1, tel: '0571-82321999', position: '120.532136,30.286291', 
          path:'/pages/redirect/index.html?scene=YrNnSS9r'
        }
        },
        {
          name: '龙游满庭芳',
          projectId: 11443,id:23, 
          signInfo: [
            { signTitle: 9, signAdd: '衢州市龙游县开源路20-1号', signNum: 10, time: '11月2日',id:23 },
          ],
          welfare: [
            { "type": 1, "title": "满庭芳限定下午茶", info: "转发即可参与" },
            { "type": 2, "title": "定制雨伞", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "2万元佣金", info: "老业主推荐的客户签约成交" }
          ],
          info: { picId: '13', name: '龙游满庭芳', address: '衢州市龙游县开源路20-1号', txt: `89-116m²全能超享纯电梯现房`, txtLine: 3, tel: '0570-7799988', position: '119.209471,29.015607', }
        },
      ]
    },
    {
      region: '苏沪区域',
      intro: [
        {
          name: '苏州月印万川',
          projectId: 11450,id:25,
          signInfo: [
            { signTitle: 27, signAdd: '苏州市相城区思贤路与金宅路交汇处向南50m', signNum: 10, time: '11月11日-11月13日' ,id:25},
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "星巴克券2张", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "非底叠佣金3万/套，底叠佣金4万/套<br/>（认购当周现金结算50%）", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '15', name: '苏州月印万川', address: '苏州市相城区思贤路与金宅路交汇处向南50m', txt: `240万起  苏州北双湖唯一现房湖边院墅`,
            txtLine: 3, tel: '0512-69398999', position: '120.725829,31.493002',
            path: '/pages/redirect/index.html?scene=RkEUVwqB'
          }
        },
        {
          name: '徐州满庭芳',
          projectId: 11376,id:24, 
          signInfo: [
            { signTitle: 22, signAdd: '徐州市铜山区三堡实验小学东约100米', signNum: 10, time: '11月12日-11月13日',id:24 },
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "送金龙鱼食用油1桶（5L）", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主享1万/套（税前）", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '14', name: '徐州满庭芳', address: '徐州市铜山区三堡实验小学东约100米', txt: `国家级高新区  全龄学府旁  <br/>均价7000+，徐州主城高品质度假社区`,
            txtLine: 3, tel: '0516-68160888', position: '117.180349,34.123138',
            path: '/pages/redirect/index.html?scene=PsEpXU3e'
          }
        },
        {
          name: '南通印澜湾',
          projectId: 11449,id:26,
          signInfo: [
            { signTitle: 11, signAdd: '南通市如东县长沙镇渤海路1号印澜湾营销中心', signNum: 10, time: '11月12日',id:26 },
            { signTitle: 23, signAdd: '南通市如东县长沙镇渤海路1号印澜湾营销中心', signNum: 10, time: '11月12日',id:26 },
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "粮油大礼包一份", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主享成交佣金2万/套（税前）", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '16', name: '南通印澜湾', address: '南通市如东县长沙镇渤海路1号印澜湾营销中心',
            txt: `首付16万起 国际海港<br/>管委会旁 实景品质洋房`, txtLine: 3, tel: '0513-84758888', position: '121.285937,32.401242',
            path: '/pages/redirect/index.html?scene=HBCbAVA3'
          }
        },
        {
          name: '南京印未来',
          projectId: 11375,id:27,
          signInfo: [
            { signTitle: 24, signAdd: '江苏省南京市雨花台区雨茂路东原印未来生活体验馆', signNum: 10, time: '11月12日',id:27},
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "老客户得100元苏果卡", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老客户享2.5%佣金（税前）", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '17', name: '南京印未来', address: '江苏省南京市雨花台区雨茂路东原印未来生活体验馆',
            txt: `南京主城江景房  三大公园在侧<br/>不到3万的价格 超出5万的产品力<br/>板块内罕见约5.6万方蓝宝石水系度假园林`, txtLine: 3, tel: '025-68896666', position: '118.657514,31.947201',
            path: '/pages/redirect/index.html?scene=hxoQW3iy'
          }
        },
        {
          name: '中骏东原·璟阅',
          projectId: 11451,id:28,
          signInfo: [
            { signTitle: 26, signAdd: '南京市栖霞区龙潭街道龙靖线中骏东原璟阅售楼处', signNum: 10, time: '11月12日-13日',id:28 },
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "定制帆布袋", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主享成交佣金4万/套（税前）及吸尘器一台", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '18', name: '中骏东原·璟阅', address: '南京市栖霞区龙潭街道龙靖线中骏东原璟阅售楼处', txt: `地铁口 学校旁 繁华商圈在侧<br/>南京主城1字头  精妆准现房`,
            txtLine: 3, tel: '025-86882999', position: '119.080747,32.187885',
          }
        },
        {
          name: '南京印宸府',
          projectId: 11452,id:29,
          signInfo: [
            { signTitle: 25, signAdd: '南京市高淳区北岭路150号印宸府营销中心', signNum: 10, time: '11月12日',id:29},
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "精美电煮锅1份", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "老业主享成交佣金3.5万/套（税前）", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '19', name: '南京印宸府', address: '南京市高淳区北岭路150号印宸府营销中心', txt: `主城芯 三中旁 临地铁<br/>低密洋房住区 全龄学府大宅`,
            txtLine: 3, tel: '025-57899888', position: '118.878232,31.332469',
            path: '/pages/redirect/index.html?scene=dmTWReWT'
          }
        },
      ]
    },
    {
      region: '华西区域',
      intro: [
        {
          name: ' 绵阳印江山195',
          projectId: 11373,id:30,
          signInfo: [
            { signTitle: 14, signAdd: '四川省绵阳市游仙区小枧镇创智路北段东原凯越印江山营销中心', signNum: 10, time: '11月5日',id:30 },
          ],
          welfare: [
            { "type": 1, "title": "/", info: "老业主在系统里面报备老带新" },
            { "type": 2, "title": "赠送江山定制茶杯（数量有限，先到先得）", info: "老业主推荐的客户到访项目" },
            { "type": 3, "title": "税前1.5%现金奖励", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '20', name: '绵阳印江山195', address: '四川省绵阳市游仙区小枧镇创智路北段东原凯越印江山营销中心',
            txt: `千亩公园旁<br/>300亩印系墅居大城`, txtLine: 3, tel: '0816-2288888', position: '104.823315,31.407172',
            path: '/pages/redirect/index.html?scene=0pcSyQzv'
          }
        },
        {
          name: ' 宜宾观天下',
          projectId: 11381,id:31,
          signInfo: [
            { signTitle: 15, signAdd: '四川省宜宾市翠屏区柏溪镇一曼路东原观天下营销中心', signNum: 10, time: '11月5-6日', id:31},
            { signTitle: 16, signAdd: '四川省宜宾市翠屏区柏溪镇一曼路东原观天下营销中心', signNum: 10, time: '11月12-13日', id:31},
          ],
          welfare: [
            { "type": 1, "title": "报备即可抽现金红包", info: "转发即可参与" },
            { "type": 2, "title": "推荐到访即可参与现场整点抽奖", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "1、推荐成交拿1.5%成交奖励（税前）<br/>2、推荐成交参股砸金蛋赢家电好礼", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '21', name: '宜宾观天下', address: '四川省宜宾市翠屏区柏溪镇一曼路东原观天下营销中心', txt: `翠屏主城<br/>300亩洋房社区`,
            txtLine: 3, tel: '0831-6067777', position: '104.553267,28.708582',
            path: '/pages/redirect/index.html?scene=2EoFkFqu'
          }
        },
        {
          name: ' 崇州江山印月',
          projectId: 11453,id:34,
          signInfo: [
            { signTitle: 17, signAdd: '成都市崇州市凤栖路555号', signNum: 10, time: '11月5-6日',id:34 },
          ],
          welfare: [
            { "type": 1, "title": "线上推荐即送项目精美小家电", info: "转发即可参与" },
            { "type": 2, "title": "业主、客户到访可送价值128元伴手礼包", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "成交税前1.5%现金奖励", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '22', name: '崇州江山印月', address: '成都市崇州市凤栖路555号', txt: `崇州主城·公园旁<br/>原创童梦洋房成长住区`, txtLine: 3,
            tel: '028-60728888', position: '103.692683,30.642897',
            path: '/pages/redirect/index.html?scene=HZUTQgDP'
          }
        },
        {
          name: ' 渭南玖城阅映阅',id:35,
          projectId: 11454,
          signInfo: [
            {id:35, signTitle: 18, signAdd: '陕西省渭南市高新区崇业路东原玖城阅营销中心', signNum: 10, time: '11月11-13日', info: '到访抽奖，有机会赢取卡塔尔世界杯官方纪念币、足球等奖品；' },
            {id:35, signTitle: 19, signAdd: '陕西省渭南市高新区崇业路东原玖城阅营销中心', signNum: 10, time: '11月11-13日', info: '双十一案场世界杯系列活动，真人手办、主题背包等多种来拿' },
          ],
          welfare: [
            { "type": 1, "title": "艾锦特家居优惠券", info: "转发即可参与" },
            { "type": 2, "title": "案场抽奖活动", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "税前1.5%佣金", info: "老业主推荐的客户签约成交" }
          ],
          info: {
            picId: '23', name: '渭南玖城阅映阅', address: '陕西省渭南市高新区崇业路东原玖城阅营销中心', txt: `高新学府旁<br/>品质进阶<br/>洋房社区`,
            txtLine: 3, tel: '0913-2817777', position: '109.425732,34.507504',
            path: '/pages/redirect/index.html?scene=aDMZxBZK'
          }
        },
      ]
    },
    {
      region: '广州区域',
      intro: [
        {
          name: ' 肇庆印江山',id:36,
          projectId: 11456,
          signInfo: [
            { signTitle: 20, signAdd: '四会市贞山新城体育馆旁东原印江山', signNum: 10, time: '11月5/6/12/13日', id:36},
          ],
          welfare: [
            { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
            { "type": 2, "title": "老带新带访送油米套装", info: "老业主推荐的客户报备并到访项目" },
            { "type": 3, "title": "总房价100万以下：佣金2万元/套<br/>总价100-150万：佣金2.5万元/套<br/>总价150万以上：佣金3万元/套", info: "老业主推荐的客户签约成交" }
          ],
          info: { picId: '24', name: '肇庆印江山', address: '四会市贞山新城体育馆旁东原印江山', txt: ` 精装山湖洋房，高拓复式<br/>超70年社群服务`,
           txtLine: 3, tel: '0756-3356888', position: '112.695744,23.315149', 
          path:'/pages/redirect/index.html?scene=FJDiM5OI'}
        },
        // {
        //   name: ' 江门印江山',
        //   projectId: 11456,
        //   signInfo: [
        //     { signTitle: 21, signAdd: '台山市台城街道南盛路与德政路交叉口东北', signNum: 10, time: '11月5、6日', },
        //     { signTitle: 22, signAdd: '台山市台城街道南盛路与德政路交叉口东北', signNum: 10, time: '11月12、13日', },
        //   ],
        //   welfare: [
        //     { "type": 1, "title": "盲盒好礼抽不停", info: "转发即可参与" },
        //     { "type": 2, "title": "无", info: "老业主推荐的客户报备并到访项目" },
        //     { "type": 3, "title": "总房价100万以下：佣金2万元/套<br/>总价100-150万：佣金2.5万元/套<br/>总价150万以上：佣金3万元/套", info: "老业主推荐的客户签约成交" }
        //   ],
        //   info: { picId: '25', name: '江门印江山', address: '台山市台城街道南盛路与德政路交叉口东北', txt: `台山城南中芯，双学府旁<br/>惟一墅质社区`, txtLine: 3, tel: '0750-5688999', position: '112.820365,22.219328', }
        // },
      ]
    }
  ]


};